import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/public/Layout";
import AdminLayout from "@/components/admin/AdminLayout";

import Home from "@/pages/public/Home";
import CmsPage from "@/pages/public/CmsPage";
import Contact from "@/pages/public/Contact";
import Recipes from "@/pages/public/Recipes";
import RecipeDetail from "@/pages/public/RecipeDetail";
import Blog from "@/pages/public/Blog";
import BlogDetail from "@/pages/public/BlogDetail";
import Testimonials from "@/pages/public/Testimonials";
import MediaCoverage from "@/pages/public/MediaCoverage";
import NotFound from "@/pages/public/NotFound";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import PagesList from "@/pages/admin/PagesList";
import PageEditor from "@/pages/admin/PageEditor";
import Slides from "@/pages/admin/Slides";
import Media from "@/pages/admin/Media";
import AdminBlog from "@/pages/admin/Blog";
import AdminRecipes from "@/pages/admin/Recipes";
import Enquiries from "@/pages/admin/Enquiries";
import ContactPage from "@/pages/admin/ContactPage";
import Settings from "@/pages/admin/Settings";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import Press from "@/pages/admin/Press";
import Audit from "@/pages/admin/Audit";

const Pub = (C) => <Layout>{C}</Layout>;

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-stone-100 text-emerald-800">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public */}
            <Route path="/" element={Pub(<Home />)} />
            <Route path="/contact" element={Pub(<Contact />)} />
            <Route path="/recipes" element={Pub(<Recipes />)} />
            <Route path="/recipes/:slug" element={Pub(<RecipeDetail />)} />
            <Route path="/blog" element={Pub(<Blog />)} />
            <Route path="/blog/:slug" element={Pub(<BlogDetail />)} />
            <Route path="/testimonials" element={Pub(<Testimonials />)} />
            <Route path="/media" element={Pub(<MediaCoverage />)} />

            {/* Admin */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin/pages" element={<Protected><PagesList /></Protected>} />
            <Route path="/admin/pages/:id" element={<Protected><PageEditor /></Protected>} />
            <Route path="/admin/slides" element={<Protected><Slides /></Protected>} />
            <Route path="/admin/media" element={<Protected><Media /></Protected>} />
            <Route path="/admin/blog" element={<Protected><AdminBlog /></Protected>} />
            <Route path="/admin/recipes" element={<Protected><AdminRecipes /></Protected>} />
            <Route path="/admin/enquiries" element={<Protected><Enquiries /></Protected>} />
            <Route path="/admin/contact-page" element={<Protected><ContactPage /></Protected>} />
            <Route path="/admin/testimonials" element={<Protected><TestimonialsAdmin /></Protected>} />
            <Route path="/admin/press" element={<Protected><Press /></Protected>} />
            <Route path="/admin/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/admin/audit" element={<Protected><Audit /></Protected>} />

            {/* CMS dynamic pages + 404 */}
            <Route path="/404" element={Pub(<NotFound />)} />
            <Route path="/:slug" element={Pub(<CmsPage />)} />
            <Route path="*" element={Pub(<NotFound />)} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
